import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
const baseClassName = ['size-8', 'flex', 'justify-center', 'rounded-xs', 'items-center', 'shrink-0', 'bg-stone-300', 'animate-pulse'].join(' ');
const NavButtonSkeleton = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames(baseClassName, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="back-button" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default NavButtonSkeleton;